import { useEffect, useRef } from 'react'
import VoucherApiHandler from 'lib/api/voucher'

export const useProductsVouchers = ({
  products,
  productsVouchers,
  updateProductsVouchersList,
}) => {
  const updateListRef = useRef(updateProductsVouchersList)

  useEffect(() => {
    updateListRef.current = updateProductsVouchersList
  }, [updateProductsVouchersList])

  const lastFetchedIdsRef = useRef('')

  useEffect(() => {
    const productIds = products?.map((p) => p?.id_product) ?? []
    const voucherIds = productsVouchers?.map((v) => v?.id_product) ?? []
    const voucherSet = new Set(voucherIds)

    const missingIds = productIds.filter(
      (id) => typeof id === 'number' && !voucherSet.has(id),
    )

    const missingIdsKey = missingIds.join(',')

    // Initialize the cleanup flag
    let isIgnore = false

    // Only fetch if we have IDs and they are different from the last fetch
    if (missingIdsKey && lastFetchedIdsRef.current !== missingIdsKey) {
      lastFetchedIdsRef.current = missingIdsKey

      const fetchVouchers = async () => {
        try {
          const res = await VoucherApiHandler.getProductsVouchers(missingIds)
          if (res && !isIgnore) {
            updateListRef.current(res)
          }
        } catch (error) {
          // eslint-disable-next-line
          console.error(error)
          lastFetchedIdsRef.current = ''
        }
      }

      fetchVouchers()
    }

    // Return the cleanup function cleanly at the very end
    return () => {
      isIgnore = true
    }
  }, [products, productsVouchers])
}

export default useProductsVouchers
